module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_22.ae1bb021.png";